import { createRpcClientV2 } from 'rpc-client-utils';
import hubHttpClient from 'hub-http/clients/apiClient';
import { createFeatureTraceWithArtifactIdRpc, stampFeatureRpc } from '../../__generated__/chirp/com/hubspot/artifact/feature/tracing/rpc/ArtifactFeatureTracingRpc';
const chirpClient = createRpcClientV2({
  hubHttpClient
});
export const stampEditorFeature = ({
  contentId,
  editorName,
  artifactType,
  featureLabel,
  metadata,
  isPublished = false
}) => {
  if (!contentId || !editorName || !artifactType) {
    return Promise.resolve();
  }
  const artifactState = isPublished ? 'PUBLISHED' : 'DRAFT';
  return chirpClient.call(createFeatureTraceWithArtifactIdRpc, {
    request: {
      artifactId: String(contentId),
      artifactState,
      artifactType
    }
  }).then(response => {
    if (response && response.featureTrace) {
      const featureTraceId = response.featureTrace.id;
      return chirpClient.call(stampFeatureRpc, {
        request: Object.assign({
          featureTraceId,
          featureLabel: featureLabel || `${editorName.toUpperCase().replace(/-/g, '_')}_EDITOR_SESSION`
        }, metadata && {
          metadata
        })
      });
    }
  }).catch(error => {
    console.error('Error stamping feature:', error);
  });
};